import ky from 'ky';

import { LIVERPOOL_FC_SCHEDULE_URL } from '../components/LiverpoolTimetable/LiverpoolTimetable';

import type { Options } from 'ky';
import type { ProgrammeItem } from '../components/Timetable/helpers';

async function getTimetable(options: Options) {
  return await ky(LIVERPOOL_FC_SCHEDULE_URL, {
    ...options,
    retry: {
      limit: 3,
      // default ky retry status codes https://github.com/sindresorhus/ky#retry
      // and status code 403 Forbidden, which sometimes occurs when requesting schedule from VG static
      statusCodes: [408, 413, 429, 500, 502, 503, 504, 403],
    },
  }).json<{ schedule: { programme: ProgrammeItem[] } }>();
}

export { getTimetable };
